import React from 'react';
import { createRoot } from 'react-dom/client';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as Sentry from '@sentry/react';

import App from './app';
import config from './config';

import '@nosferatu500/react-sortable-tree/style.css';
import './style.css'; // override style on tree.

Sentry.init({
  dsn: 'https://f2b7621168d59ff4c65c1a61df1f1a50@o4509129290612736.ingest.de.sentry.io/4509129668493392',
  integrations: [Sentry.browserTracingIntegration()],
  environment: config.sentryEnvironment,
  tracesSampleRate: 0.0,
  enabled: config.sentryEnabled,
  ignoreErrors: [
    'TypeError: Failed to fetch',
    'TypeError: Load failed',
  ],
});

const container = document.getElementById('app')!;
const root = createRoot(container);

root.render(<App />);
